import React, { Component } from "react";
import { Button, Modal, HelpBlock } from "react-bootstrap";

import { destroy } from "../../../utils/DeApi";
import { FieldGroup } from "../../../utils/BootstrapUtils";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import Loader from "../../Loader/Loader";

class ProjectDelete extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      show: false,
      projectName: ""
    };

    this.handleShowModal = this._handleShowModal.bind(this);
    this.handleCloseModal = this._handleCloseModal.bind(this);
    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleInputChange = this._handleInputChange.bind(this);
  }

  _handleCloseModal() {
    this.setState({ show: false });
  }

  _handleShowModal() {
    this.setState({ show: true });
  }

  _handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  _handleSubmit(event) {
    event.preventDefault();
    const projectId = this.props.project.id;
    const projectName = this.props.project.name;
    if (this.state.projectName === projectName) {
      this.setState({ isLoading: true, formError: "" });
      const destroyPromise = destroy("/projects/" + projectId);
      destroyPromise.promise
        .then(response => {
          this.setState({
            projectName: "",
            error: "",
            show: false,
            isLoading: false
          });
          this.props.onProjectDeleted();
        })
        .catch(error => {
          !error.isCanceled &&
            this.setState({
              error: error,
              isLoading: false
            });
        });
      this.subscribedPromises.push(destroyPromise);
    } else {
      this.setState({
        formError: "Project names do not match."
      });
    }
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function(promise) {
      promise.cancel();
    });
  }

  render() {
    const helpBlock = this.state.formError ? (
      <HelpBlock>{this.state.formError}</HelpBlock>
    ) : (
      ""
    );

    const form = this.state.isLoading ? (
      <Loader />
    ) : (
      <form onSubmit={this.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title className="mt-0">
            Are you sure you want to delete this project?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FieldGroup
            id="projectName"
            name="projectName"
            label="Please type in the name of the project to confirm."
            type="text"
            onChange={this.handleInputChange}
            value={this.state.projectName}
            validationState="warning"
            placeholder="Enter a name for the project to delete"
            required
          />
          {helpBlock && helpBlock}
          {this.state.error && <ErrorHandler error={this.state.error} />}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.handleCloseModal}>Cancel</Button>
          <Button type="submit" bsStyle="danger">
            Delete
          </Button>
        </Modal.Footer>
      </form>
    );

    return (
      <div>
        <Button bsStyle="link" onClick={this.handleShowModal}>
          Delete Project
        </Button>
        <Modal
          show={this.state.show}
          onHide={this.handleCloseModal}
          backdrop="static"
        >
          {form}
        </Modal>
      </div>
    );
  }
}

export default ProjectDelete;
